import api from "../apiapp";

const OperationFileService = {

  getOperationFileSearch: async function (model) {
    var filters = '';
		if(model.account !== '' && model.account !== null){ filters += '&filter[comitente]='+model.account; }
		if(model.filename !== '' && model.filename !== null){ filters += '&filter[escoOperation]='+model.filename; }
		if(model.status !== '' && model.status !== null){ filters += '&filter[status]='+model.status; }
		if(model.oficial !== '' && model.oficial !== null){ filters += '&filter[oficialDeCuenta]='+model.oficial; }
		if(model.opetype !== '' && model.opetype !== null){ filters += '&filter[tipoOperacion]='+model.opetype; }
		if(model.opereason !== '' && model.opereason !== null){ filters += '&filter[escoOperationReasonToSend]='+model.opereason; }
		if(model.dateFrom !== '' && model.dateFrom !== null){ filters += '&filter[from]='+model.dateFrom; }
		if(model.dateTo !== '' && model.dateTo !== null ){ filters += '&filter[to]='+model.dateTo}; 
    
    const response = await api.request({
      url: 'esco-operation-details?page[size]=100&sort='+model.orderby+'&include=escoOperationReasonToSend,escoOperationMailLogs,escoOperation,escoOperationStatus'+filters.toString(),
      method: "GET",
      data: model
    })
    
    return response.data
  },
  getOperationsFilePagination: async function (url) {
    const response = await api.request({
      url: url,
      method: "GET",
    })
    
    return response.data
  },
  putOperationAuthStatus: async function (id, model) {
    const response = await api.request({
      url: 'esco-operation-details/'+id+'/change-status',
      method: "PUT",
      data: model
    })
    
    return response.data
  },
  putOperationAuthComments: async function (id, model) {
    const response = await api.request({
      url: 'esco-operation-details/'+id+'/update-note',
      method: "PUT",
      data: model
    })
    
    return response.data
  },
  setOperationSendAuthNotification: async function (model) {
    const response = await api.request({
      url: 'esco-and-fund-operations/send-operations/',
      method: "POST",
      data: model
    })
    
    return response.data
  },
  setOperationResendAuthNotification: async function (model) {
    const response = await api.request({
      url: 'esco-and-fund-operations/resend-operations/',
      method: "POST",
      data: model
    })
    
    return response.data
  },
  setOperationAuthNotification: async function (model) {
    const response = await api.request({
      url: 'esco-operation-details/send-operations/',
      method: "POST",
      data: model
    })
    
    return response.data
  },
  setOperationUploadFile: async function (model) {
    const response = await api.request({
      url: 'esco-operations/import/excel',
      method: "POST",
      data: model
    })
    
    return response.data
  },

}

export default OperationFileService;